<template>
  <div class="bless-reward-wrapper">
    <div class="reward-content">
      <div class="reward-content-mask" v-show="showMask"></div>
      <!-- rewardType 0:积分页面 1：优惠券页面 2：饲料奖励 -->
      <p class="title">
        {{ getTitle }}
      </p>

      <!-- 无奖励 -->
      <div class="no-reward" v-if="showNoReward">
        <img src="../images/yj_no_reward_icon.png" />
      </div>
      <template v-else>
        <!-- 饲料奖励 -->
        <!-- <div class="reward-score" v-if="rewardData.rewardType === 2">
          <img class="score-bg" src="../images/yj_score_sl.png" />
        </div> -->
        <!-- 优惠券奖励 -->
        <div
          class="reward-coupon"
          v-if="rewardData.rewardType === REWARD_TYPE_ENUM.COUPON"
        >
          <img
            class="reward-coupon-bg"
            src="../images/yj_single_coupon_bg.png"
          />
          <span class="item-price">
            <span class="item-price-text">¥</span>
            <span v-text="getValueFunc(rewardData)"></span>
          </span>
          <div class="item-content">
            <span class="item-title" v-text="getNameFunc(rewardData)"></span>
            <span class="item-desc" v-text="getUseScopeFunc(rewardData)"></span>
          </div>
        </div>
        <!-- 积分或者云币奖励 -->
        <div class="reward-score" v-if="showRewardScoreOrCoin">
          <img class="score-bg" :src="getScoreBg" />
          <span class="score-txt" :data-text="rewardData.rewardValue">{{
            rewardData.rewardValue
          }}</span>
        </div>
      </template>
      <div
        :class="[
          {
            'score-margin': rewardBottomImgMarginTop,
          },
          'reward-bottom-img',
        ]"
      >
        <img src="../images/yj_bless_opening.png" />
      </div>
      <p class="count-down-text" v-show="showMask">
        {{ countDownTime }}s后自动关闭
      </p>
    </div>
    <!-- 虚拟云币 -->
    <template v-if="rewardData.rewardType === REWARD_TYPE_ENUM.VIRTUAL_COIN">
      <div class="reward-tip">
        <p>奖励已放入“我的奖励”{{ getExchangeTime }}提取</p>
        <p class="reward-tip-account">（{{ getFormatReceivePhone }}账户）</p>
      </div>
      <div class="to-my-reward">
        <span @click="showMiniProgramCodeImage">我的奖励 ></span>
        <wx-open-launch-weapp
          class="wx-open-launch-weapp"
          :username="getWxAppId"
          :path="weappPath"
          v-if="showWeappTag"
          @launch="handleLaunchFn"
        >
          <script type="text/wxtag-template">
            <style>.btn { opacity: 0; width: 300px; height: 30px; display: block;border-radius: 0px;}</style>
            <button class="btn">打开小程序</button>
          </script>
        </wx-open-launch-weapp>
      </div>
    </template>
  </div>
</template>

<script>
/**
 * 奖励类型
 */
import { mapState } from 'vuex'
import { VIP_CALL_ERROR_CODE_ENUM } from '../../../common/define/errorCodeEnum'
import yjScoreBg from '../images/yj_score_bg.png'
import yjVirtualCoinBg from '../images/yj_virtual_coin_bg.png'
import { protectPhoneNum } from '../../../common/utils/commonUtil.js'
import YunJi from '@/common/js/YunJi.js'
import teamList from '../../groupon/components/teamList.vue'
import {
  wxOpenLaunchWeappTagIsValid,
  getWxAppOriginId
} from '../../../common/utils/wxUtil.js'

const REWARD_TYPE_ENUM = {
  SCORE: 0, // 积分
  COUPON: 1, // 优惠券
  COIN: 2, // 云币
  /**
   * 虚拟云币
   */
  VIRTUAL_COIN: 3
}
/**
 * 使用范围
 */
const USE_SCOPE_ENUM = {
  ALL: 0, // 全场通用(除跨境商品)
  SPE_CATEGORY: 1, // 指定类目
  SPE_GOODS: 2, // 指定商品
  SPE_COUPON: 3, // 指定品牌团
  SPE_SUBJECT: 4 // 指定专题
}

export default {
  components: { teamList },
  name: 'blessReward',
  data() {
    return {
      REWARD_TYPE_ENUM,
      showMask: true,
      countDownTime: 2,
      // 小程序二维码
      qrcodeImage: null
    }
  },
  props: {
    code: {
      type: Number,
      default: 0
    },
    rewardData: {
      type: Object | Array,
      default() {
        return {}
      }
    },
    receivePhone: {
      type: String,
      default: ''
    },
    virtualCoinActivity: {
      type: Object,
      default() {
        return {}
      }
    },
    /**
     * 显示小程序跳转组件
     */
    showWeappTag: {
      type: Boolean,
      default: false
    },
    /**
     * 小程序路径
     */
    weappPath: {
      type: String,
      default: ''
    },
    /**
     * 小程序id
     */
    getWxAppId: {
      type: String,
      default: ''
    }
  },
  watch: {},
  computed: {
    ...mapState([
      'appCont',
      'shopId',
      'luckBagCode',
      'smsId'
    ]),
    /**
     * 跳转小程序按钮是否有效
     */
    wxOpenLaunchWeappTagIsValid() {
      return wxOpenLaunchWeappTagIsValid()
    },
    showNoReward() {
      // 未命中|活动已结束|已领取
      return (
        this.code === VIP_CALL_ERROR_CODE_ENUM.RELATION_REWARD_HIT
        || this.code === VIP_CALL_ERROR_CODE_ENUM.RELATION_ACTIVITY_CLOSE
        // this.code === VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_RECEIVE ||
        || this.code === VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_RECEIVE_TODAY
        || this.code === VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_HIT 
        || this.code === VIP_CALL_ERROR_CODE_ENUM.RELATION_LUCK_BAG_INVALIDATE
      )
    },
    getTitle() {
      if (
        this.code === VIP_CALL_ERROR_CODE_ENUM.RELATION_REWARD_HIT
        || this.code === VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_RECEIVE_TODAY
        || this.code === VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_HIT
      ) {
        return '好遗憾，没有抽中噢～'
      }
      if (this.code === VIP_CALL_ERROR_CODE_ENUM.RELATION_ACTIVITY_CLOSE || this.code === VIP_CALL_ERROR_CODE_ENUM.RELATION_LUCK_BAG_INVALIDATE) {
        return '活动已结束，下次早点来噢～'
      }
      if (this.code === VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_RECEIVE) {
        return '今天已领过奖品，请明天再来'
      }

      if (this.rewardData) {
        if (this.rewardData.rewardType == REWARD_TYPE_ENUM.SCORE) {
          return `恭喜获得${this.rewardData.rewardValue}积分`
        } if (this.rewardData.rewardType == REWARD_TYPE_ENUM.COUPON) {
          return `恭喜获得${
            this.rewardData.detail && this.rewardData.detail.name
          }`
        } if (
          this.rewardData.rewardType == REWARD_TYPE_ENUM.COIN
          || this.rewardData.rewardType == REWARD_TYPE_ENUM.VIRTUAL_COIN
        ) {
          return `恭喜获得${this.rewardData.rewardValue}云币`
        }
      }
      return ''
    },
    showRewardScoreOrCoin() {
      return (
        this.rewardData.rewardType === REWARD_TYPE_ENUM.SCORE
        || this.rewardData.rewardType === REWARD_TYPE_ENUM.COIN
        || this.rewardData.rewardType === REWARD_TYPE_ENUM.VIRTUAL_COIN
      )
    },
    getScoreBg() {
      if (
        this.rewardData.rewardType === REWARD_TYPE_ENUM.SCORE
        || this.rewardData.rewardType === REWARD_TYPE_ENUM.COIN
      ) {
        return yjScoreBg
      } 
      return yjVirtualCoinBg
    },
    getFormatReceivePhone() {
      return protectPhoneNum(this.receivePhone)
    },
    getExchangeTime() {
      const exchangeTime = this.virtualCoinActivity && this.virtualCoinActivity.exchangeTime
      return exchangeTime
        ? YunJi.filterFormatDate(exchangeTime, 'MM月dd日')
        : ''
    },
    rewardBottomImgMarginTop() {
      return (
        (this.rewardData.rewardType === REWARD_TYPE_ENUM.SCORE
          || this.rewardData.rewardType === REWARD_TYPE_ENUM.COIN
          || this.rewardData.rewardType === REWARD_TYPE_ENUM.VIRTUAL_COIN)
        && !this.showNoReward
      )
    }
  },
  methods: {
    handleLaunchFn() {
      console.log('跳转小程序组件跳转成功  success')
      if (this.rewardData.rewardType === REWARD_TYPE_ENUM.VIRTUAL_COIN) {
        // 我的奖励
        thinkingReport.track('others', {
          point_id: '27095',
          page_id: '80740',
          content_id: this.luckBagCode,
          sms_id: this.smsId
        })
      }
      // eslint-disable-next-line no-unused-expressions
      // document.getElementById('launchBox') && document.getElementById('launchBox').remove()
    },
    /**
     * 点击“我的奖励”，跳转专题
     */
    showMiniProgramCodeImage() {
      // 福袋奖品页-我的奖励
      thinkingReport.track('others', {
        point_id: '27095',
        page_id: '80740',
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
      this.$emit('SHOW_MINIPROGRAM_CODE_IMAGE')
      // let subjectId =
      //   this.virtualCoinActivity && this.virtualCoinActivity.subjectId;
      // window.location.href = `//${globalConfig.yunjibuyerPath}/yj/subject?subjectId=${subjectId}&shopId=${this.shopId}&appCont=${this.appCont}`
    },
    /**
     * 根据奖励类型获取标题
     */
    getNameFunc(item) {
      let title = ''
      switch (item.rewardType) {
        case REWARD_TYPE_ENUM.COUPON:
          title = (item.detail && item.detail.name) || ''
          // title = `${item.rewardValue}元无门槛优惠券`;
          break
        case REWARD_TYPE_ENUM.SCORE:
          title = `${item.rewardValue}积分`
          break
        case REWARD_TYPE_ENUM.COIN:
          title = `${item.rewardValue}元云币`
          break
      }
      return title
    },
    /**
     * 根据奖励类型获取价值
     */
    getValueFunc(item) {
      let value = 0
      switch (item.rewardType) {
        case REWARD_TYPE_ENUM.SCORE:
          value = `${item.rewardValue || 0}`
          break
        case REWARD_TYPE_ENUM.COUPON:
          value = `${(item.detail && item.detail.value) || 0}`
          break
        case REWARD_TYPE_ENUM.COIN:
          value = `${item.rewardValue || 0}`
          break
      }
      return value
    },
    /**
     * 获取适用范围
     */
    getUseScopeFunc(item) {
      let content = ''
      let useScope = ''
      switch (item.rewardType) {
        case REWARD_TYPE_ENUM.SCORE:
          useScope = USE_SCOPE_ENUM.SPE_GOODS
          break
        case REWARD_TYPE_ENUM.COUPON:
          useScope = item.detail && item.detail.useScope
          break
        case REWARD_TYPE_ENUM.COIN:
          useScope = USE_SCOPE_ENUM.SPE_GOODS
          break
      }
      switch (useScope) {
        case USE_SCOPE_ENUM.ALL:
          // content = "全场通用(除跨境商品)";
          break
        case USE_SCOPE_ENUM.SPE_CATEGORY:
          content = '指定类目 '
          break
        case USE_SCOPE_ENUM.SPE_GOODS:
          content = '指定商品可用'
          break
        case USE_SCOPE_ENUM.SPE_COUPON:
          content = '指定品牌团'
          break
        case USE_SCOPE_ENUM.SPE_SUBJECT:
          content = '指定专题'
          break
      }
      return content
    },
    /**
     * 倒计时
     */
    startCountDown() {
      setTimeout(() => {
        this.countDownTime--
        if (this.countDownTime > 0) {
          this.startCountDown()
        } else {
          this.showMask = false
        }
      }, 1000)
    }
  },
  mounted() {
    if (this.code == 0) {
      this.startCountDown()
      this.showMask = true
    } else {
      this.showMask = false
    }
  }
}
</script>
<style>
.wx-open-launch-weapp {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
<style lang="less" scoped>
.bless-reward-wrapper {
  width: 100%;
  .reward-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .reward-content-mask {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.4);
      z-index: 1;
    }
    .title {
      font-size: 0.36rem;
      font-weight: bold;
      color: #ffe6c8;
      position: relative;
      z-index: 1;
    }
    .reward-coupon {
      width: 5.12rem;
      height: 2.12rem;
      margin: 0.5rem auto 0;
      position: relative;
      color: #ee2532;
      z-index: 1;
      .reward-coupon-bg {
        width: 100%;
        height: 100%;
      }
      .item-price {
        position: absolute;
        width: 1.9rem;
        font-size: 0.52rem;
        line-height: 0.52rem;
        text-align: center;
        font-weight: bold;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        .item-price-text {
          position: relative;
          bottom: 0.02rem;
          font-size: 0.24rem;
          line-height: 0.24rem;
        }
      }
      .item-content {
        position: absolute;
        left: 2.1rem;
        top: 50%;
        transform: translateY(-50%);
        .item-title {
          font-size: 0.28rem;
          font-weight: bold;
          overflow: hidden;
          width: 2.6rem;
          display: block;
          max-height: 0.7rem;
        }
        .item-desc {
          display: block;
          font-size: 0.24rem;
          margin-top: 0.1rem;
        }
      }
    }
    .reward-score {
      width: 3.36rem;
      position: relative;
      z-index: 1;
      .score-bg {
        display: block;
        width: 100%;
      }
      .score-txt {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.8rem;
        line-height: 0.8rem;
        font-family: "DINAlternate-Bold";
        color: #fff044;
        text-shadow: 0 2px 4px rgba(255, 100, 0, 0.8);
      }
      .score-txt:before {
        content: attr(data-text);
        position: absolute;
        // z-index: 10;
        color: #ffffe6;
        mask: linear-gradient(to bottom, #fff044, transparent);
      }
    }
    .no-reward {
      margin-top: 0.4rem;
      width: 1.58rem;
      position: relative;
      img {
        display: block;
        width: 100%;
      }
    }
    .reward-bottom-img {
      width: 100%;
      position: relative;
      &.score-margin {
        margin-top: -0.8rem;
      }
      img {
        width: 100%;
        display: block;
      }
    }
    .count-down-text {
      font-size: 0.28rem;
      color: white;
      position: absolute;
      z-index: 1;
      bottom: 2.5rem;
    }
  }
  .reward-tip {
    font-size: 0.32rem;
    color: #fffab4;
    text-align: center;
    line-height: 0.44rem;
    margin-top: 0.24rem;
    .reward-tip-account {
      font-size: 0.28rem;
    }
  }
  .to-my-reward {
    font-size: 0.24rem;
    color: #ffffff;
    text-align: center;
    margin: 0.1rem auto 0;
    position: relative;
  }
}
</style>
